import {initWebComponent} from "@/helpers/web-component-helper";
import {postGeoAhn3D} from "@/http/services/http-services-geo";
import {getArea, getLength} from "ol/sphere";
import {WKT} from "ol/format";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {measureAhn} from "@/helpers/measure/measure-ahn-helper";
import {OL3Parser, WKTReader} from "jsts/org/locationtech/jts/io";
import {GeometryFactory} from "jsts/org/locationtech/jts/geom";
import {BufferOp} from "jsts/org/locationtech/jts/operation/buffer";
import {Feature} from "ol";
import {LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon} from "ol/geom";
import {createBufferByGeometry} from "@/helpers/measure/measure-buffer-helper";
import {hideElementsBySelector} from "@/helpers/element-helper";

export class LayerInfoInfoItemGeometryMeasureAhnComponent extends HTMLElement {
    constructor(){
        super();

        const geometryType = this.getAttribute('data-geometry-type')

        const template = document.createElement('template');

        let message = 'Let op bij grote gebieden! Stel bij groter dan 1000 m2 een tussenafstand in van 2m. of groter.'
        let hideElement = ''
        if(geometryType === 'LineString') {
            if(getLength(window.measureOlFeature.getGeometry()).toFixed(2) > 1000) {
                hideElement = 'd-none'
                message = 'Weergave van een 3D lijn kan tot maximaal 1km lang zijn'
            } else {
                message = ''
            }
        }

        template.innerHTML = `
                        <div class="row ${hideElement}">
                           <div class="col-6 mt-2">Tussenafstand</div>
                           <div class="col-6">
                               <div class="input-group">
                                  <input type="text" class="form-control" value="1">
                                  <span class="input-group-prepend">
                                    <span class="input-group-text pl-2 pr-2">m2</span>
                                  </span>
                                  <span class="input-group-append">
                                    <button class="btn btn-xs btn-default" data-type="show" type="button">Laat zien</button>
                                    <button class="btn btn-xs btn-default d-none" data-type="remove" type="button">Verbergen</button>
                                  </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <small>${message}</small>
                            </div>
                            <div class="col-12" id="divMeasureResult">
                            </div>
                            <div class="col-12">
                                <a target="_blank" href="" class="btn btn-xs btn-default btn-block mt-1 d-none" id="aMeasureResult">Open in nieuw venster</a>
                            </div>
                        </div>
                    </div>`

        initWebComponent(this, template)

        const wkt = new WKT()

        this.addEventListener('click', (e) => {
            if(!e.target.getAttribute('data-type')) {
                return
            }

            const divMeasureResult = this.querySelector('#divMeasureResult')

            if(e.target.getAttribute('data-type') === 'remove') {
                divMeasureResult.innerHTML = ''
                hideElementsBySelector('#aMeasureResult')

                this.querySelector('button[data-type="show"]').classList.remove('d-none')
                this.querySelector('button[data-type="remove"]').classList.add('d-none')

                this.querySelector('input').value = 1
            } else {

                this.querySelector('button[data-type="remove"]').classList.remove('d-none')
                this.querySelector('button[data-type="show"]').classList.add('d-none')

                const olFeature = window.measureOlFeature.clone()

                let projection = olFeature.get('kv_projection')
                let olGeometry = olFeature.getGeometry().clone()

                if(projection) {
                    olGeometry = olGeometry.transform(projection, 'EPSG:28992')
                }

                let isLine = false
                if(olGeometry.getType() !== 'Polygon') {
                    olGeometry = createBufferByGeometry(olGeometry, 1)
                    isLine = true
                }

                const step = this.querySelector('input').value
                const area = getArea(olGeometry)
                const wktString = wkt.writeGeometry(olGeometry)
                measureAhn(divMeasureResult, olGeometry,  wktString, area, step, isLine)
            }
        })
    }
}

